import {
  CLEAR_OAUTH_SETTINGS,
  REQUEST_OAUTH_USER_DATA,
  REQUEST_OAUTH_USER_DATA_ERROR,
  RECEIVE_OAUTH_USER_DATA,
  REMOVE_OAUTH_LOCAL_STORAGE_VALUE
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

export default oauth

const oauthUserDatareducer = createApiMiddlewareReducer({
  request: REQUEST_OAUTH_USER_DATA,
  failure: REQUEST_OAUTH_USER_DATA_ERROR,
  receive: RECEIVE_OAUTH_USER_DATA
})

function oauth(state = {}, { type, payload = {} }) {
  if (payload === null) return state
  switch (type) {
    case CLEAR_OAUTH_SETTINGS:
      return {
        ...state,
        [payload.provider]: {}
      }
    case REQUEST_OAUTH_USER_DATA:
    case REQUEST_OAUTH_USER_DATA_ERROR:
    case RECEIVE_OAUTH_USER_DATA:
      let oauthKey = `${payload.workspaceId}-${payload.sourceSlug}-${payload.provider}-userdata`
      if (payload.integrationSlug)
        oauthKey = `${payload.workspaceId}-${payload.sourceSlug}-${payload.integrationSlug}-${payload.provider}-userdata`
      return {
        ...state,
        [oauthKey]: oauthUserDatareducer(state[oauthKey], { type, payload })
      }
    case REMOVE_OAUTH_LOCAL_STORAGE_VALUE:
      return {
        ...state,
        localStorageFlags: {
          ...state.localStorageFlags,
          [payload.key]: null
        }
      }
    default:
      return state
  }
}
